export const FONT_HEADING = "'Hanken Grotesk', sans-serif";
export const FONT_BODY = "'Inter', sans-serif";
export const FONT_MONO = "'JetBrains Mono', monospace";

export const RECAPTCHA_TEST_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

export const IMAGE_ACCEPT = "image/jpeg,image/png,image/gif,image/webp";
export const VIDEO_ACCEPT = "video/mp4,video/webm,video/quicktime";

export const MAX_IMAGE_SLOTS = 3;
export const MAX_VIDEO_SLOTS = 1;
export const TOTAL_EVIDENCE_SLOTS = MAX_IMAGE_SLOTS + MAX_VIDEO_SLOTS;

export const MIN_DESCRIPTION_LENGTH = 10;

export const ERROR_COLOR = "#ba1a1a";
